export default __webpack_public_path__ + "static/media/ethereum.cf8aa5e7.svg";